import {Component, Input} from '@angular/core';
import {AmountStatus} from "@model";

@Component({
  selector: 'app-amount-status-badge',
  templateUrl: './amount-status-badge.component.html',
  styleUrl: './amount-status-badge.component.scss',
  standalone: false

})
export class AmountStatusBadgeComponent {
  @Input() amountStatus: AmountStatus = AmountStatus.NOT_PAID;

  protected readonly AmountStatus = AmountStatus;
}
